import {
  Component,
  input,
  InputSignal,
  model,
  ModelSignal,
  OnInit,
  output,
  signal,
  WritableSignal,
} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SvgSpriteIcon} from '../svg-sprite';

@Component({
  selector: 'lib-sidebar',
  imports: [CommonModule],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
  host: {
    '(window:resize)': 'onWindowResize()',
  },
})
export class SidebarComponent implements OnInit {
  protected readonly SvgSpriteIcon = SvgSpriteIcon;

  title: InputSignal<string | undefined> = input<string | undefined>();
  breakPoint = input(1023);

  hideable: WritableSignal<boolean> = signal(this.#hideCheck());
  hidden: ModelSignal<boolean> = model(this.hideable());


  dynamic = output<boolean>();

  #timeoutId: ReturnType<typeof setTimeout> | undefined;

  ngOnInit(): void {
    this.hideable.set(this.#hideCheck());
    this.dynamic.emit(this.hideable());
  }

  toggle(): void {
    this.hidden.set(this.hideable() && !this.hidden());
  }

  onWindowResize(): void {
    clearTimeout(this.#timeoutId);
    this.#timeoutId = setTimeout(() => {
      this.hideable.set(this.#hideCheck());
      this.dynamic.emit(this.hideable());
    }, 50);
  }

  #hideCheck(): boolean {
    return window.innerWidth < this.breakPoint();
  }
}
